// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"stores_wrapper__l_4fQ","title":"stores_title__av7pk","list":"stores_list__EEQTx","listItem":"stores_listItem__ip6fD"};